<div class="row">
<div class="col-sm-12 col-md-6 col-md-offset-3">
    <div *ngIf="status == 'completed'" class="row line-footer">
        <div class="col-sm-12 col-md-12 success-msg">
            <div class="hide-sm"><i aria-hidden="true" class="icon-controls-approvalL icon-large"> </i> <h3> Success </h3> <p> You've successfully added {{totalRecords}} users.</p> </div>
            <div class="show-sm"><i aria-hidden="true" class="icon-approval"> </i> <h3> Success </h3> <p>You've successfully added {{totalRecords}} users.</p> </div>
        </div>
    </div>
  <div  *ngIf="status == 'errorAll'">
    <div class="alert valign-children-middle">
        <div class="alert-error" aria-label="Alert">
            <i class="icon-badgealert" aria-hidden="true"></i>
        </div>
        <div>
            <h2>Users already exist</h2>
            <p>The users you're trying to add are already in the system.</p>
        </div>
    </div>
    <p>To add new users, create a file containing new users only, and then upload that file.</p>
  </div>
    <div *ngIf="status == 'error'">
        <p>
            You successfully added {{totalRecords}} users. The users who were not added are duplicates and are already in the system.
        </p>
        <app-customgrid [gridOptions]="gridOptions"></app-customgrid>
    </div>
    <hr class="mar-tb-30">
    <div class="line-footer text-right">
        <button class="btn btn-secondary btn-sm-block pull-right" *ngIf="status != 'errorAll'" (click)="assignUnassignWizard();" aria-label="Assign or un-assign licenses.">Assign or un-assign licenses</button>
        <button class="btn btn-secondary btn-sm-block pull-right" *ngIf="status == 'errorAll'" (click)="gotoPage('/bulkUsers');" aria-label="Add users.">Add users</button>
        <a href="javascript:void(0)" class="btn btn-sm-block btn-link" (click)="gotoPage('/dashboard');">Console dashboard </a>
    </div>
</div>
</div>